import { FC, Fragment, useEffect, useState } from 'react';
import { getHFee } from 'services/cms';

interface HandleFeeProps {
  name: string;
}
const HandleFee: FC<HandleFeeProps> = ({ name }) => {
  const [data, setData] = useState<any>();

  useEffect(() => {
    (async () => {
      const res = await getHFee(name);

      setData(res);
    })();
  }, []); // eslint-disable-line

  return (
    <Fragment>
      {!!data && (
        <div className="mb-20">
          <div className="title text-md mb-5">{data.desc}</div>
          <div dangerouslySetInnerHTML={{ __html: data.body }}></div>
        </div>
      )}
    </Fragment>
  );
};

export default HandleFee;
